var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBlock)?_c('div',{staticClass:"block-wrapper"},_vm._l((_vm.links),function(link){return _c('div',{key:link.url},[_c('router-link',{attrs:{"to":link.url}},[_vm._v(_vm._s(link.text))])],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }